/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Runs_SubtitleInputs */



/**
* | output |
* | --- |
* | "Every headless run of this agent, newest first." |
*
* @param {Agent_Runs_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_runs_subtitle = /** @type {((inputs?: Agent_Runs_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Runs_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Hintergrundläufe dieses Agenten, neueste zuerst.")
	return /** @type {LocalizedString} */ ("Every headless run of this agent, newest first.")
});